export const SuccessIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2473_3665)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.99984 18.3334C14.6022 18.3334 18.3332 14.6024 18.3332 10C18.3332 5.39765 14.6022 1.66669 9.99984 1.66669C5.39746 1.66669 1.6665 5.39765 1.6665 10C1.6665 14.6024 5.39746 18.3334 9.99984 18.3334ZM6.48109 8.51772L9.0738 11.1115L13.5186 6.66669L14.9998 8.14794L9.0738 14.074L4.99984 10L6.48109 8.51772Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_2473_3665">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
